import { ListBase } from 'components/views/pages/list/ListBase';

export default ListBase;
